import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface AvailableForBackgroundGigsProps {
  band: Band
}

interface SelectOption {
  value: string | null
  label: string
}

export const AvailableForBackgroundGigs: React.FC<AvailableForBackgroundGigsProps> = ({
  band,
}) => {
  const options: SelectOption[] = [
    { value: null, label: "Select availability..." },
    {
      value: "currently_available",
      label: "Yes, currently available for background gigs",
    },
    {
      value: "not_currently_available",
      label: "We aren't currently available, but do sometimes play background gigs",
    },
    {
      value: "never_available",
      label: "No, we don't do background gigs",
    },
  ]

  const fieldData = {
    field: "available_for_background_gigs",
    name: "availableForBackgroundGigs",
    label: "Available for Background Gigs",
    placeholder: "Select availability",
    required: false,
  }

  return (
    <EditBandFormField
      type="select"
      fieldData={fieldData}
      bandId={band.id}
      options={options}
    />
  )
}
